module.exports = __webpack_public_path__ + "static/img/Game.59bcd11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/funplus/imgs/browse/Game.jpg
// module id = 1951
// module chunks = 0